import { Chip } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { gql } from "@outschool/ui-apollo";
import React from "react";

import * as Activity from "../../shared/Activity";
import { ActivityStatusLabel_ActivityFragment } from "../../shared/generated/graphql";
import { EnrolledClassActivity } from "./enrolled/EnrolledClassTypes";

export default function ActivityStatusLabel({
  activity,
  size = "small"
}: {
  activity: ActivityStatusLabel_ActivityFragment | EnrolledClassActivity;
  size?: "medium" | "small" | undefined;
}) {
  const { t } = useTranslation("client\\components\\ActivityStatusLabel");
  if (Activity.isArchived(activity)) {
    return <Chip color="warning" size={size} label={t("Archived")} />;
  } else if (Activity.isPublished(activity)) {
    return <Chip color="success" size={size} label={t("Listed")} />;
  } else if (Activity.requestedListingAt(activity)) {
    return <Chip color="warning" size={size} label={t("Listing Requested")} />;
  } else if (Activity.isRejected(activity)) {
    return <Chip color="warning" size={size} label={t("Revision Required")} />;
  } else {
    return <Chip color="warning" size={size} label={t("Not Listed")} />;
  }
}

ActivityStatusLabel.fragments = {
  // TODO(cp): Move Activity.isArchived/isPublished/etc to graphql
  activity: gql`
    fragment ActivityStatusLabel_activity on Activity {
      archived_at
      published_at
      requested_listing_at
      approvalStatus {
        action
        message_to_teacher
      }
    }
  `
};
